import { apiClient } from '@/api/api'
import type { TasteMatchingCardsResponse } from '@/features/taste/types/taste-config'

/**
 * `GET /taste-matching/cards/next?style_id=<code>&limit=` — unswiped outfits of one
 * style. The API has no "N per style" session yet (BE-151), so Rate asks per style.
 */
export async function fetchStyleQuizCards(
  styleCode: string,
  limit: number,
): Promise<TasteMatchingCardsResponse> {
  const response = await apiClient.get<TasteMatchingCardsResponse>('/taste-matching/cards/next', {
    params: { style_id: styleCode, limit },
  })
  return response.data
}

interface StyleQuizMatchingConfig {
  styles?: Array<{ id: number; code: string }>
}

/**
 * Style id → code. `/user/style` and `available-styles` carry no code, and
 * `cards/next` filters by code — `GET /taste-matching/config` has both.
 */
export async function fetchStyleQuizStyleCodes(): Promise<Map<number, string>> {
  const response = await apiClient.get<StyleQuizMatchingConfig>('/taste-matching/config')
  return new Map((response.data.styles ?? []).map((style) => [style.id, style.code]))
}
